module.exports = __webpack_public_path__ + "img/logoCut.24898dc8.svg";